import { Action } from 'redux';

import { IContentInfo } from '../../../ts/models/IContentInfo';
import { WhoHasSeenThisView } from '../AppActionTypes';
import { isActionFactory } from '../isActionFactory';

export interface WhoHasSeenThisViewAction extends Action {
  view: IContentInfo;
}

export function whoHasSeenThisView(view: IContentInfo) {
  return {
    type: WhoHasSeenThisView,
    view
  };
}

export const isWhoHasSeenThisViewAction = isActionFactory<WhoHasSeenThisViewAction>(WhoHasSeenThisView);
